const path = {
    index: '/',
    about: '/about',
    contact: '/contact',
    markets: '/markets',
    communications: '/communications',
}

export default path
